module.exports = __webpack_public_path__ + "img/one.171cb41b.png";